import React from 'react';
import { ArrowUp, Heart } from 'lucide-react';

const VendorHeaderInfo = ({ vendor, isFavorited, onToggleFavorite, onShare, isLoading = false, isAuthenticated = false }) => {
  return (
    <div className="space-y-4 sm:space-y-6">
      {/* Title and Action Buttons - Airbnb Style */}
      <div className="flex items-start justify-between gap-4">
        {/* Title */}
        <div className="flex-1 min-w-0">
          <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-3xl font-light text-black leading-tight break-words">
            {vendor?.business_name}
          </h1>
        </div>

        {/* Action Buttons - Airbnb Style with underlined text */}
        <div className="flex gap-4 sm:gap-6 flex-shrink-0">
          <button
            onClick={onShare}
            className="flex items-center gap-1.5 sm:gap-2 text-black hover:opacity-70 transition-opacity touch-manipulation"
            aria-label="Share vendor"
          >
            <ArrowUp className="w-4 h-4 sm:w-5 sm:h-5" />
            <span className="text-sm sm:text-base underline font-light">Share</span>
          </button>
          {isAuthenticated && (
            <button
              onClick={onToggleFavorite}
              disabled={isLoading}
              className="flex items-center gap-1.5 sm:gap-2 text-black hover:opacity-70 transition-opacity touch-manipulation disabled:opacity-50 disabled:cursor-not-allowed"
              aria-label={isFavorited ? 'Remove from favorites' : 'Add to favorites'}
            >
              <Heart className={`w-4 h-4 sm:w-5 sm:h-5 transition-all ${isFavorited ? 'fill-current text-red-500' : ''} ${isLoading ? 'animate-pulse' : ''}`} />
              <span className="text-sm sm:text-base underline font-light">
                {isLoading ? 'Saving...' : 'Save'}
              </span>
            </button>
          )}
        </div>
      </div>

    </div>
  );
};

export default VendorHeaderInfo;

